import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from "axios"
import * as qs from "qs"
import nock from "nock"
import { Config, DefaultHeaders } from "./types/request"

interface Reply {
  status?: number
  body?: any
  params?: any
}

export class HttpTestBase {
  public host: string
  public reply: Reply = {
    status: 0,
    body: "",
    params: {},
  }

  constructor(host: string) {
    this.host = host
  }

  public async get(path: string, config?: Config): Promise<AxiosResponse> {
    this.scope
      .get(path)
      .query(this.reply.params)
      .once()
      .reply(this.reply.status, this.reply.body)
    return this.http.get(path, { ...config })
  }

  public async post(
    path: string,
    body: any,
    config?: Config
  ): Promise<AxiosResponse> {
    this.scope
      .post(path)
      .query(this.reply.params)
      .once()
      .reply(this.reply.status, this.reply.body)
    return this.http.post(path, body, { ...config })
  }

  public async patch(
    path: string,
    body: any,
    config?: Config
  ): Promise<AxiosResponse> {
    this.scope
      .patch(path)
      .query(this.reply.params)
      .once()
      .reply(this.reply.status, this.reply.body)
    return this.http.patch(path, body, { ...config })
  }

  public async delete(path: string, config?: Config): Promise<AxiosResponse> {
    this.scope
      .delete(path)
      .query(this.reply.params)
      .once()
      .reply(this.reply.status, this.reply.body)
    return this.http.delete(path, { ...config })
  }

  public async request(config: AxiosRequestConfig): Promise<AxiosResponse> {
    this.requestScope
      .intercept(config.url!, config.method!)
      .query(this.reply.params)
      .once()
      .reply(this.reply.status, this.reply.body)
    return axios({ ...config, url: `${this.host}${config.url}` })
  }

  set replyData({ status, body, params }: Reply) {
    this.reply.status = status
    this.reply.body = JSON.stringify({ ...body })
    this.reply.params = { ...params }
  }

  get scope() {
    return nock(this.host)
  }

  get requestScope() {
    return nock(this.host)
  }

  get headers() {
    const headers: Partial<DefaultHeaders> = {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    }

    return headers
  }

  get http(): AxiosInstance {
    const http = axios.create({
      baseURL: this.host,
      headers: this.headers,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "brackets" })
      },
    })

    return http
  }
}
